import { RootState } from "index";

export const selectIndices = (state: RootState) => state.indices